import React from 'react';
import './App.css';
import { Modal, Form } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup'
import Figure from 'react-bootstrap/Figure'
import Spinner from 'react-bootstrap/Spinner'



class SearchItem extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		
	}

	handleChange(event){
		this.setState({searchQuery:event.target.value},()=>{
			if(this.state.searchQuery.length>2){
				this.props.onSearchPerfomed(this.state.searchQuery)
			}//else if(this.state.searchQuery.length>0){this.props.onResetSuggestions();}
		});		
	}

	handleClose(event){
		this.props.onCloseSearch();
	}

	handleSubmit(idref){		
		this.props.onItemSelected(idref);
	}

	handleLoaded(e,idref){		
		//console.log('Loaded ' +idref);
		this.props.onLoadedSuggestion(idref);
	}

	hilightTerms(idref){
		let start = idref.indexOf(this.state.searchQuery)+1;
		return(
			<>
				{idref.substring(0,start)}
				<mark class="hilight">
					{idref.substring(start,start+this.state.searchQuery.length)}
				</mark>
				{idref.substring(start+this.state.searchQuery.length)}
			</>
			);			
	}

	render(){
		return (
			<Modal style={{width:'800'}} show={this.props.shouldShow} onHide={this.handleClose} >
	          <Modal.Header closeButton>
	            <Modal.Title>{this.props.searchTitle}</Modal.Title>
	          </Modal.Header>
	          <Modal.Body>
				<Form.Control type="text" onChange={(e)=>this.handleChange(e)} maxLength="50" style={{"width":"100%"}} />
				<ListGroup>
					{
						this.props.suggestions.map((suggestion)=>{
							return (
								<ListGroup.Item key={suggestion.idref}> 
									<Figure>										
										<Spinner animation="grow" style={{display:(suggestion.loaded?'none':'')}} />
									  	<img id={suggestion.idref} onLoad={(event)=>this.handleLoaded(event,suggestion.idref)} onClick={(e)=>this.handleSubmit(suggestion.idref)} width="423px" alt={suggestion.format} src={suggestion.url} />
									  	<Figure.Caption>
									  		{suggestion.idref}-{suggestion.updated_at}
									  	</Figure.Caption>
									</Figure>
								</ListGroup.Item>
							);
						})
					}
				</ListGroup>
	          </Modal.Body>	         
	        </Modal>
	    )
	}

}

export default SearchItem;